import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { ErreurMappingService } from '../../services/errors/erreur-mapping.service';
import { AccessibiliteService } from '../../services/accessibilite.service';
import { FormulaireFiservService } from 'src/app/services/formulaire-fiserv/formulaire-fiserv.service';

@Component({
  selector: 'app-modale',
  templateUrl: './modale.component.html',
  standalone: false,
})
export class ModaleComponent implements OnInit {
  showValue = false;
  constructor(
    readonly navigationService: NavigationService,
    readonly erreurMappingCanadaForm: ErreurMappingService,
    readonly accessibiliteService: AccessibiliteService,
    readonly globalStoreService: GlobalStoreService,
    private readonly formulaireFiservService: FormulaireFiservService
  ) {}

  ngOnInit(): void {
    this.globalStoreService.getEtatModale().subscribe((etat) => (this.showValue = etat));
  }

  @HostListener('window:oel-header-transactionnel.boutonRetourCliquee')
  handleBoutonAnnulerHeader(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }
  showDialog() {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
  }
  redirectionAccueil() {
    this.formulaireFiservService.setForm(null);
    this.globalStoreService.saveUpdateDataForm(null);
    this.erreurMappingCanadaForm.resetFormsError();
    this.globalStoreService.saveEtatAfficherModaleAnnuler(false);
    this.accessibiliteService.setFocus('h1');
    this.navigationService.naviguerVersAccueil();
  }
}
